import { CloseIcon } from "@/components/icons";
import { IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Notification, NotificationProps } from "./Notification";

export interface NotificationManagementProps {
  notification: null | NotificationProps;
}

const NotificationManagement = ({
  notification,
}: NotificationManagementProps) => {
  const [open, setOpen] = useState(false);
  const [notificationMessage, setNotificationMessage] =
    useState<null | NotificationProps>({
      title: "",
      message: "",
      severity: undefined,
    });

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    if (notification) {
      setNotificationMessage({
        title: notification.title,
        message: notification.message,
        severity: notification.severity,
      });
      setOpen(true);
    }
  }, [notification]);

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" className="transition hover:opacity-50" />
    </IconButton>
  );

  return (
    <Notification
      open={open}
      title={notificationMessage?.title}
      message={notificationMessage?.message}
      severity={notificationMessage?.severity}
      onClose={handleClose}
      action={action}
    />
  );
};

export { NotificationManagement };
